import React from 'react';
import PropTypes from 'prop-types';
import { Box,  Button, Summary, Icon } from '@deity/falcon-ui';
import { toGridTemplate } from '@deity/falcon-ecommerce-uikit';
import {H2, Input} from "benlux-ecommerce-ui";

const ignoreClick = ev => ev.preventDefault();

const CheckoutHeaderArea = {
  icon: 'icon',
  title: 'title',
  summary: 'summary',
  button: 'button'
};

const checkoutHeaderLayout = {
  checkoutHeaderLayout: {
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: 'xs',
    // prettier-ignore
    gridTemplate: toGridTemplate([
      ['40px',                  '40px',                    '1fr',                      '100px'                  ],
      [CheckoutHeaderArea.icon, CheckoutHeaderArea.title, CheckoutHeaderArea.summary, CheckoutHeaderArea.button]
    ])
  }


};

const buttonChange = {
  buttonChange: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    color: '#696969',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 8,
    cursor: 'pointer',
  }
}

const SectionHeader = ({ complete, open, title, summary, editLabel, onActionClick }) => (
  <Summary onClick={ignoreClick} defaultTheme={checkoutHeaderLayout} css={{ 'summary:after': { display: 'none' }, outline: 'none', marginBottom: 10 }}>
    <H2 open={open} title={title}/>
    {summary && (
      <Box ml="lg" pt="xs" gridArea={CheckoutHeaderArea.summary}>
        {summary}
      </Box>
    )}
    {complete && (
      <div onClick={onActionClick} style={buttonChange.buttonChange}>
        {editLabel === 'Logout' ? 'Se déconnecter' : 'Modifier'}
      </div>

    )}
  </Summary>
);

SectionHeader.propTypes = {
  complete: PropTypes.bool,
  open: PropTypes.bool,
  title: PropTypes.string,
  summary: PropTypes.shape({}),
  editLabel: PropTypes.string,
  onActionClick: PropTypes.func
};

export default SectionHeader;
